import { createEventFactory, createName } from '@cp/shared/tracking';

export const TrainingEvents = {
  trainingStartEvent: createEventFactory({
    name: createName('client', 'trainig', 'show'),
    goalId: 'poyavlenie_popapa_projti_proverku_dlya_ispolnitelya',
    goalName: 'poyavlenie_popapa_projti_proverku_dlya_ispolnitelya',
  }),
} as const;
